import { Link } from "react-router-dom";
import { NavLink, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { API } from "../../config/api";
import "./../Styles/sidebar.css";
import "./../Styles/AddDesigner.css";
import "./../Styles/Addmachine.css";
import "./../Styles/ChangePassword.css";
import "./../Styles/logout.css";
import "./../Styles/profile.css";
import "./../Styles/viewworkspace.css";

import "./../Styles/Addworkspace.css";

import "./../Styles/new.css";

const closeSidebarMobile = () => {
  if (window.innerWidth <= 768) {
    document.body.classList.remove("sidebar-open");
  }
};

export default function Sidebar() {
  const [supplierOpen, setSupplierOpen] = useState(false);
  const [allSupplierTypes, setAllSupplierTypes] = useState([]);

  // Loading state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [DesignOpen, setDesignOpen] = useState(null);
  // Initialize user state from session storage (fallback)
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("user")) || {};
    } catch {
      return {};
    }
  });

  useEffect(() => {
    const fetchSupplierTypes = async () => {
      try {
        const response = await fetch(
          `${API.BASE_URL}/api.php?action=supplier_types`,
        );

        const result = await response.json();

        if (result.status) {
          setAllSupplierTypes(result.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchSupplierTypes();
  }, []);
  const fetchUserData = async () => {
    try {
      setLoading(true);
      setError(null);

      const savedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
      const userId = savedUser.id || sessionStorage.getItem("userId");

      if (!userId) return;

      const response = await fetch(`${API.GET_USER}?id=${userId}`);

      const result = await response.json();

      if (result.success) {
        const cleanUser = {
          id: result.user.id,
          name: result.user.name,
          email: result.user.email,
          phone: result.user.phone,
          provider_options: result.user.provider_options || [],
          supplier_types: result.user.supplier_types || [],
          role: result.user.role,
          account_type: result.user.account_type,
          status: result.user.status,
        };

        sessionStorage.setItem("user", JSON.stringify(cleanUser));
        sessionStorage.setItem("userId", cleanUser.id);

        setUser(cleanUser);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  // Listen for "userLogin" event to refresh data
  useEffect(() => {
    // const refreshUser = async () => {
    //   try {
    //     const userId =
    //       sessionStorage.getItem("userId") || localStorage.getItem("userId");

    //     if (userId) {
    //       const response = await fetch(API.LIST_USERS);

    //       if (response.ok) {
    //         const result = await response.json();
    //         if (result.success && result.users) {
    //           const currentUser = result.users.find(
    //             (u) => String(u.id) === String(userId),
    //           );
    //           if (currentUser) {
    //             const cleanUser = {
    //               id: currentUser.id,
    //               name: currentUser.name,
    //               email: currentUser.email,
    //               phone: currentUser.phone,
    //               provider_options: currentUser.provider_options,
    //               supplier_types: currentUser.supplier_types,
    //               role: currentUser.role,
    //               account_type: currentUser.account_type,
    //             };
    //             sessionStorage.setItem("user", JSON.stringify(cleanUser));
    //             setUser(cleanUser);
    //           }
    //         }
    //       }
    //     }
    //   } catch (err) {
    //     console.error("Error refreshing user data:", err);
    //   }
    // };

    window.addEventListener("userLogin", fetchUserData);
    window.addEventListener("refreshSidebar", fetchUserData);

    return () => {
      window.removeEventListener("userLogin", fetchUserData);
      window.removeEventListener("refreshSidebar", fetchUserData);
    };
  }, []);

  const refreshUser = async () => {
    try {
      const userId = sessionStorage.getItem("userId");

      if (!userId) return;

      const response = await fetch(`${API.GET_USER}?id=${userId}`);
      const result = await response.json();

      if (result.success) {
        const cleanUser = {
          ...result.user,
          provider_options: result.user.provider_options || [],
          supplier_types: result.user.supplier_types || [],
        };

        sessionStorage.setItem("user", JSON.stringify(cleanUser));
        setUser(cleanUser);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    refreshUser();
  }, []);

  useEffect(() => {
    const syncUser = () => {
      const updatedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
      setUser(updatedUser);
    };

    window.addEventListener("refreshSidebar", syncUser);
    window.addEventListener("storage", syncUser);

    return () => {
      window.removeEventListener("refreshSidebar", syncUser);
      window.removeEventListener("storage", syncUser);
    };
  }, []);
  const getRoles = () => {
    if (!user.provider_options) return [];

    let options = user.provider_options;

    // handle JSON string
    if (typeof options === "string") {
      try {
        options = JSON.parse(options);
      } catch {
        options = options.split(",");
      }
    }

    return Array.isArray(options)
      ? options.map((r) => r.trim().toLowerCase())
      : [];
  };
  const getSupplierTypes = () => {
    if (!user.supplier_types) return [];

    let types = user.supplier_types;

    if (typeof types === "string") {
      try {
        types = JSON.parse(types);
      } catch {
        types = types.split(",");
      }
    }

    return Array.isArray(types) ? types.map((t) => t.trim().toLowerCase()) : [];
  };
  const userSupplierTypes = getSupplierTypes();

  const allowedSupplierTypes = allSupplierTypes.filter((supplier) => {
    return userSupplierTypes.some((userType) =>
      userType.toLowerCase().includes(supplier.type.toLowerCase()),
    );
  });

  // Handle provider_options as string or array
  //  const getRoles = () => {
  //   if (!user.provider_options) return [];

  //   // Handle both array and string formats
  //   let options = user.provider_options;

  //   if (typeof options === 'string') {
  //     options = options.split(',')
  //                      .map(role => role.trim().toLowerCase())
  //                      .filter(role => role.length > 0);
  //   }

  //   return Array.isArray(options) ? options : [];
  // };
  useEffect(() => {
    const fetchSupplierTypes = async () => {
      try {
        const response = await fetch(
          `${API.BASE_URL}/api.php?action=supplier_types`,
        );

        const result = await response.json();

        if (result.status) {
          setAllSupplierTypes(result.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchSupplierTypes();
  }, []);
  const roles = getRoles();

  // Permissions based on provider_options
  const canMachine = roles.includes("machines");
  const canDesigner = roles.includes("designers");
  const canWorkspace = roles.includes("workspaces");
  const isSupplier = roles.includes("supplier");
  const canDesigns = roles.includes("designs");
  const canSketcher = roles.includes("sketcher");
  const canJobworker = roles.includes("job_worker");
  // Show loading state while fetching
  if (loading) {
    return (
      <div className="us-container">
        <div className="us-sidebar">
          <h2 className="us-logo">User Panel</h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "2rem",
              color: "#666",
              fontSize: "14px",
            }}
          >
            <i
              className="bi bi-hourglass-split"
              style={{ fontSize: "2rem", marginBottom: "0.5rem" }}
            ></i>
            <span>Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  // Show error state but still render sidebar with fallback data
  if (error && Object.keys(user).length === 0) {
    return (
      <div className="us-container">
        <div className="us-sidebar">
          <h2 className="us-logo">User Panel</h2>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "2rem",
              color: "#e74c3c",
              fontSize: "14px",
            }}
          >
            <i
              className="bi bi-exclamation-triangle"
              style={{ fontSize: "2rem", marginBottom: "0.5rem" }}
            ></i>
            <span>Failed to load user data</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="us-container">
      <div
        className="sidebar-overlay"
        onClick={() => document.body.classList.remove("sidebar-open")}
      ></div>

      <div className="us-sidebar">
        {/* <h2 className="us-logo">User Panel</h2> */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {" "}
          {/* <img
            src="/logo.png"
            alt="Embroidery Bazar"
            style={{ height: "50px", objectFit: "contain" }}
            className="pe-2"
          /> */}
          <h2 className="us-logo">User Panel</h2>
        </div>
        <ul className="us-menu">
          {/* Dashboard - Always visible */}
          <li>
            <NavLink
              to="/user/dashboard"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-speedometer2"></i>
              <span>Dashboard</span>
            </NavLink>
          </li>

          {canDesigner && (
            <>
              {" "}
              <li>
                <NavLink
                  to="/user/add-designer"
                  className="us-link"
                  onClick={closeSidebarMobile}
                >
                  <i className="bi bi-palette"></i>
                  <span>Create Designer Profile</span>
                </NavLink>

                {/* <div
                className="us-menu-title"
                onClick={() => setDesignerOpen(!designerOpen)}
              >
                <div className="us-menu-left">
                  <i className="bi bi-palette"></i>
                  <span>Manage Designers</span>
                </div>
                <i
                  className={`bi ${
                    designerOpen ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </div>
              {designerOpen && (
                <ul className="us-submenu">
                  <li>
                    <Link to="/user/add-designer" onClick={closeSidebarMobile}>
                      Add Designer
                    </Link>
                  </li>
                </ul>
              )} */}
              </li>
              <li>
                <NavLink
                  to="/user/myBids"
                  className="us-link"
                  onClick={closeSidebarMobile}
                >
                  <i className="bi bi-person-badge"></i>
                  <span>My Bids</span>
                </NavLink>
              </li>
            </>
          )}
          {canSketcher && (
            <li>
              <NavLink
                to="/user/add-sketcher"
                className="us-link"
                onClick={closeSidebarMobile}
              >
                <i className="bi bi-vector-pen"></i>
                <span>Create Sketcher Profile</span>
              </NavLink>
            </li>
          )}

          {canDesigns && (
            <>
              <div
                className="us-menu-title"
                onClick={() => setDesignOpen(!DesignOpen)}
              >
                <div className="us-menu-left">
                  <i className="bi-pencil-square"></i>
                  <span>Upload Paid Design</span>
                </div>
                <i
                  className={`bi ${
                    DesignOpen ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </div>
              {DesignOpen && (
                <ul className="us-submenu">
                  <li>
                    <NavLink to="/user/designs" onClick={closeSidebarMobile}>
                      Upload Design
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/user/Payment-Details"
                      onClick={closeSidebarMobile}
                    >
                      Receive Payment Details
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/user/terms" className="us-link">
                      <span>Terms & Condition</span>
                    </NavLink>
                  </li>
                </ul>
              )}
              {/* <li>
                <Link
                  to="/user/designs"
                  className="us-link"
                  onClick={closeSidebarMobile}
                >
                  <i className="bi-pencil-square"></i>
                  <span>Uploads Designs</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/user/Payment-Details"
                  className="us-link"
                  onClick={closeSidebarMobile}
                >
                  <i className=" bi bi-wallet2"></i>
                  <span>Payment Details</span>
                </Link>
              </li>
              <li>
                <Link to="/user/terms" className="us-link">
                  <i className="bi bi-file-earmark-text"></i>
                  <span>Terms & Condition</span>
                </Link>
              </li> */}
            </>
          )}

          {/* Machines - Conditional */}
          {canMachine && (
            <li>
              <NavLink
                to="/user/add-machine"
                className="us-link"
                onClick={closeSidebarMobile}
              >
                <i className="bi bi-gear"></i>
                <span> Add sale Machine Details</span>
              </NavLink>
              {/* <div
                className="us-menu-title"
                onClick={() => setMachineOpen(!machineOpen)}
              >
                <div className="us-menu-left">
                  <i className="bi bi-gear"></i>
                  <span>Manage Machines</span>
                </div>
                <i
                  className={`bi ${
                    machineOpen ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </div>
              {machineOpen && (
                <ul className="us-submenu">
                  <li>
                    <Link to="/user/add-machine" onClick={closeSidebarMobile}>
                      Add Machine
                    </Link>
                  </li>
                </ul>
              )} */}
            </li>
          )}

          {/* Designers - Conditional */}

          {/* Workspace - Conditional */}
          {canWorkspace && (
            <li>
              <NavLink
                to="/user/add-workspace"
                className="us-link"
                onClick={closeSidebarMobile}
              >
                <i className="bi bi-building"></i>
                <span>Add Rent Space Details</span>
              </NavLink>
              {/* <div
                className="us-menu-title"
                onClick={() => setWorkspaceOpen(!workspaceOpen)}
              >
                <div className="us-menu-left">
                  <i className="bi bi-building"></i>
                  <span>Manage Workspace</span>
                </div>
                <i
                  className={`bi ${
                    workspaceOpen ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </div>
              {workspaceOpen && (
                <ul className="us-submenu">
                  <li>
                    <Link to="/user/add-workspace" onClick={closeSidebarMobile}>
                      Add Workspace
                    </Link>
                  </li>
                </ul>
              )} */}
            </li>
          )}

          {(canMachine || canWorkspace || canDesigns) && (
            <li>
              <NavLink
                to="/user/transactions"
                className="us-link"
                onClick={closeSidebarMobile}
              >
                <i className="bi bi-wallet2"></i>
                <span>Transaction Details</span>
              </NavLink>
            </li>
          )}
          {canJobworker && (
            <>
              {/* <li>
                <Link
                  to="/user/add-work"
                  className="us-link"
                  onClick={closeSidebarMobile}
                >
                  <i className="bi bi-file-earmark-plus"></i>
                  <span>Add Work</span>
                </Link>
              </li> */}
              <li>
                <NavLink
                  to="/user/add-work"
                  className="us-link"
                  onClick={closeSidebarMobile}
                >
                  <i className="fa-solid fa-screwdriver-wrench"></i>
                  <span>Add Work</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/user/add-hiring"
                  className="us-link"
                  onClick={closeSidebarMobile}
                >
                  <i className="bi bi-person-plus-fill"></i>
                  <span>Add Hiring</span>
                </NavLink>
              </li>
            </>
          )}

          {isSupplier && (
            <li>
              <div
                className="us-menu-title"
                onClick={() => setSupplierOpen(!supplierOpen)}
              >
                <div className="us-menu-left">
                  <i className="bi bi-truck"></i>
                  <span>Add Supplier Detail</span>
                </div>

                <i
                  className={`bi ${
                    supplierOpen ? "bi-chevron-up" : "bi-chevron-down"
                  }`}
                ></i>
              </div>

              {supplierOpen && (
                <ul className="us-submenu">
                  {allowedSupplierTypes.map((supplier) => (
                    <li key={supplier.id}>
                      <NavLink
                        to={`/user/${supplier.type}`}
                        onClick={closeSidebarMobile}
                        className="us-link"
                      >
                        {supplier.display_name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          )}

          {/* Profile - Always visible */}
          <li>
            <NavLink
              to="/user/profile"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-person-circle"></i>
              <span>Profile</span>
            </NavLink>
          </li>
          {/* <li>
            <Link to="/user/terms" className="us-link">
              <i className="bi bi-file-earmark-text"></i>
              <span>Terms & Condition</span>
            </Link>
          </li> */}
          {/* Logout - Always visible */}
          <li>
            <NavLink
              to="/user/logout"
              className="us-link"
              onClick={closeSidebarMobile}
            >
              <i className="bi bi-box-arrow-right"></i>
              <span>Logout</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
}
